import { Validateable } from "./interfaces/validateable";

export class RewardClaim extends Validateable {
	private terms_signed: boolean = false;
	private current_month_claim: boolean = false;
	private opt_in_best2: boolean = false;

	public acceptedTerms(): boolean {
		return this.terms_signed;
	}

	public acceptedEligibility(): boolean {
		return this.current_month_claim;
	}

	public acceptedBest2(): boolean {
		return this.opt_in_best2;
	}
}
